export default {
  title: 'Artículos',
};
